function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.063 15c.507 0 .937-.39.937-.938V7.5h3.398a.77.77 0 00.547-1.328L11.008.234c-.274-.273-.781-.273-1.055 0L4.016 6.172A.77.77 0 004.562 7.5H8v6.563c0 .546.39.937.938.937h3.124zm8.437-.313a.95.95 0 00-.938-.937H14.25v.313c0 1.21-1.016 2.187-2.188 2.187H8.938a2.184 2.184 0 01-2.188-2.188v-.312H1.437a.925.925 0 00-.937.938v4.374c0 .547.39.938.938.938h18.125c.507 0 .937-.39.937-.938v-4.375zm-4.844 3.438c0 .43-.351.781-.781.781a.783.783 0 01-.781-.781c0-.43.351-.781.781-.781.43 0 .781.351.781.781zm2.5 0c0 .43-.351.781-.781.781a.783.783 0 01-.781-.781c0-.43.351-.781.781-.781.43 0 .781.351.781.781z",
  fill: "#1174DC"
})));